import { ArrowBack, ArrowForward } from 'assets/icons';
import Button from 'components/common/Button';
import { Formik } from 'formik';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import s from '../../calculators.module.scss';
import BuyingHouseEstimationForm from './BuyingHouseEstimationForm';
import validationSchema from '../yupSchemas/buyingHouseSecondStepSchema';

const Buttons = ({ isEditMode, onBack, values, previousStep, isSubmitting }) => {
  const { formatMessage: t } = useIntl();

  return (
    <div className={s.buttonsWrapper}>
      {!isEditMode ? (
        <Button disabled={isSubmitting} onClick={() => onBack(values, previousStep)} startIcon={<ArrowBack />}>
          {t({ id: 'app.back' })}
        </Button>
      ) : null}
      <Button
        type="submit"
        loading={isSubmitting}
        disabled={isSubmitting}
        endIcon={isEditMode ? <SaveIcon /> : <ArrowForward />}
        className="ml-auto"
      >
        {t({ id: `app.${isEditMode ? 'save' : 'submit_form_next'}` })}
      </Button>
    </div>
  );
};

const BuyingHouseSecondStep = ({
  currentStep,
  formValuesRef,
  isEditMode,
  lastStep,
  onSubmit,
  onSubmitStep,
  nextStep,
  previousStep,
  hasAdditionalFeatures,
  onBack,
}) => {
  const onSubmitFormHandler = useCallback(
    async (values, formikActions) => {
      const step = !isEditMode && values.additional_features ? currentStep : null;
      onSubmitStep(values);
      await onSubmit({
        values,
        formikActions,
        currentStep: step,
        isEditMode: !values.additional_features,
        lastStep,
        nextStep,
      });
    },
    [currentStep, isEditMode, lastStep, nextStep, onSubmit, onSubmitStep],
  );

  return (
    <Formik initialValues={formValuesRef?.current} onSubmit={onSubmitFormHandler} validationSchema={validationSchema}>
      {(props) => (
        <BuyingHouseEstimationForm
          {...{
            hasAdditionalFeatures,
            buttons: <Buttons {...{ isEditMode, onBack, previousStep, ...props }} />,
            ...props,
          }}
        />
      )}
    </Formik>
  );
};

export default BuyingHouseSecondStep;
